import BaseQuizGame from "./BaseQuizGame.js";
import { renderFlagDuelError } from "../utils/FlagUtils.js";

/**
 * Capitale → Pays : the reverse of Capital Nerd Classic. The question is a
 * capital (text) and the 4 choices are country names. Lives-based, full set.
 * Everything else (proposal generation, click handling, lives, sharing,
 * end-game stats) is inherited from BaseQuizGame / BaseGame — only the
 * question rendering and the error recap are customised.
 */
export default class CapitalNerdReverse extends BaseQuizGame {
	constructor() {
		super('capitalnerdreverse', '.capital-nerd-reverse', {
			passportStamp: "capital",
			gameNameKey: "home.capitalNerd",
			modeLabelKey: "home.reverse",
			mode: "reverse",
			shareEmoji: "🟩",
			slug: "capital-nerd-reverse"
		});
		if (!this.page) return;

		this.init();
	}

	renderQuestion(country) {
		return `<div class="capital-prompt">${country.capital}</div>`;
	}

	getQuestionFlagCodes() {
		return [];
	}

	buildError(guessBtn) {
		return {
			capital: this.rightAnswer.capital,
			countryName: this.rightAnswer.name,
			correctCode: this.rightAnswer.code,
			guessedCode: guessBtn.dataset.countryCode
		};
	}

	renderErrorItem(error) {
		return renderFlagDuelError(error, error.capital);
	}
}
